function VerificaOrdiniRipetitivi() {

    var divOrdiniRip = $('#divOrdiniRipetitivi');
    if (divOrdiniRip && divOrdiniRip.length > 0) {
        var cbData = $('#cbData').dxCheckBox('instance');

        var dbData = $('#dbDataDesiderata').dxDateBox('instance');
        var dbDataValue = dbData.option('value');
        var hData = $('#hDataDesiderata');

        if (cbData.option('value') == true) {
            if (dbDataValue && dbDataValue != '01/01/0001 00:00:00') {
                hData.val(dateformat(cbData.option('min')));
                return true;
            }
        }
        else {
            return true;
        }
        dbData.option("isValid", false);
        return false;
    }
    return true;
}

function InizializzaCarrello() {
    try {
        if (typeof dataLayer !== "undefined") {
            var p = {};
            p.ga4event = "view_cart";

            mainController.CallServiceAsync("/Checkout/GetCartDetail", p)
                .then(function (r) {
                    if (r != null && r != undefined) {
                        var products = JSON.parse(r.JsonObject);
                        if (products != null && products != undefined) {
                            ga4.e_pushEventMulti(products, "view_cart", r.Valuta, "", r.TotaleOrdine, r.CodiceBuonoSconto);
                        }
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        }
    }
    catch (error) {
        console.log(error);
    }

    try {
        var queryString = undefined;
        queryString = mainController.getUrlVars()["error"];

        if (queryString) {
            var messaggio = undefined;
            switch (queryString) {
                case 'TotaliOrdine':
                    messaggio = 'lTotaleOrdineErrato';
                    break;
                case 'CreazioneOrdine':
                    messaggio = 'lErroreCreazioneOrdine';
                    break;
                default:
                    breaK;
            }

            if (messaggio) {
                mainController.NotifyMessageTimed(mainController.GetLabel(messaggio), 'error', 10000);

                //pulisco l'url
                var urlObj = new URL(window.location.href);
                urlObj.search = '';
                history.replaceState(null, '', urlObj.toString());
            }
            else {
                console.log('Cannot find message from query string \'error\'');
            }
        }
    }
    catch (error) {
        console.log(error);
    }

    $(window).resize(GrandezzaPopup);
}

function GrandezzaPopup() {
    var altezza = window.innerHeight;
    var larghezza = window.innerWidth;

    if (larghezza <= 850) {
        $('#popupDatiUtente').dxPopup('instance').option('height', '65%');
        $('#popupDatiUtente').dxPopup('instance').option('width', '60%');
    }
    else {
        $('#popupDatiUtente').dxPopup('instance').option('height', '55%');
        $('#popupDatiUtente').dxPopup('instance').option('width', '40%');
    }
}

function ProseguiCarrello(piva, sdi, pec, usertype, forzaAvanti) {

    var valid = false;

    try {
        if (forzaAvanti != true) {

            valid = VerificaOrdiniRipetitivi();

            if (valid == true) {
                if (piva && piva?.trim()?.length > 0) {
                    if (sdi?.length == 0 && pec?.length == 0) {

                        if (usertype && usertype?.length > 0 && parseInt(usertype) > 0) {
                            var div = $('#divTipoUtente');

                            if (div && div.length > 0) {
                                div.addClass('hidden');
                            }
                        }

                        $('#popupDatiUtente').dxPopup('instance').show();

                        valid = false;
                    }
                }
            }
        }
        else {
            valid = true;
        }

    } catch (ex) {
        console.error(ex);
    }
    return valid;
}

function popupDatiUtente_OnContentReady(e, usertype) {
    try {

        GrandezzaPopup();

        var chkCampi = $('#chkCampi');
        chkCampi[0].style.setProperty('display', 'none', 'important');

        var passaUsertype = true;
        if (usertype && usertype?.length > 0 && parseInt(usertype) > 0) {
            var div = $('#divTipoUtente');

            if (div && div.length > 0) {
                div.addClass('hidden');
                passaUsertype = false;
            }
        }

        var form = $('#fDatiMancantiUtente');
        form.submit((e) => {
            e.preventDefault();

            var txtSDI = $('#DatiMancantiSDI');
            var txtPEC = $('#DatiMancantiPEC');

            if (txtPEC.val()?.length > 0 || txtSDI.val()?.length > 0) {
                try {
                    waitingBS.Show();

                    var params = {
                        SDI: txtSDI.val(),
                        PEC: txtPEC.val()
                    };

                    if (passaUsertype == true) {
                        params.Usertype = $('#DatiMancantiUsertype').val();
                    }

                    mainController.CallServiceAsync(form.attr('action'), params)
                        .then((risp) => {
                            if (risp) {
                                if (risp.esito == Costanti.ESITO_OK) {
                                    var btn = document.getElementById('bconfermacarrello');

                                    btn.addEventListener('click', () => {
                                        return true;
                                    })

                                    setTimeout(() => {
                                        $('#fconfermacarrello').submit();
                                    }, 4000);
                                }
                                else {
                                    waitingBS.Hide();
                                }
                                mainController.NotifyMessageTimed(risp.responseText, risp.NotifyColor, 10000);
                            }
                        })
                        .catch((err) => {
                            console.error(err);
                            waitingBS.Hide();
                        })

                } catch (ex) {
                    console.error(ex);
                    waitingBS.Hide();
                }
            }
            else {
                txtSDI.addClass('is-invalid');
                txtPEC.addClass('is-invalid');
                chkCampi[0].style.setProperty('display', 'block', 'important');
            }
        });

    } catch (ex) {
        console.error(ex);
    }
}

function fDatiMancantiUtente_Validation() {
    var valid = true;

    try {
        var chkCampi = $('#chkCampi');
        var chkSDI = $('#msgsdi');

        chkCampi[0].style.setProperty('display', 'none', 'important');
        chkSDI[0].style.setProperty('display', 'none', 'important');

        var txtSDI = $('#DatiMancantiSDI');
        var txtPEC = $('#DatiMancantiPEC');

        txtSDI.removeClass('is-invalid');
        txtPEC.removeClass('is-invalid');

        if (txtPEC.val()?.length == 0 && txtSDI.val()?.length == 0) {
            txtSDI.addClass('is-invalid');
            txtPEC.addClass('is-invalid');
            chkCampi[0].style.setProperty('display', 'block', 'important');
            valid = false;
        }
        else {
            if (txtPEC.val()?.length > 0) {
                if (mainController.CheckEmail(txtPEC.val()) == false) {
                    txtPEC.addClass('is-invalid');
                    valid = false;
                }
            }

            if (txtSDI.val()?.length > 0) {
                if (CheckSdi(txtSDI) == false) {
                    txtSDI.addClass('is-invalid');
                    chkSDI[0].style.setProperty('display', 'block', 'important');
                    valid = false;
                }
            }
        }

    } catch (ex) {
        console.error(ex)
        valid = false;
    }

    return valid;
}